export default __webpack_public_path__ + "static/prof_development-dbfb60fcdf9bf4ab15690525fd836a20.svg";